import styled from 'styled-components';
import device from '../mediaQueries';

const UserLink = styled.a`
  ${device.desktop`
    height: 18px;
    color: ${({ color = '#999999' }) => color};
    font-family: "Avenir", "Arial", sans-serif;
    font-size: 13px;
    font-weight: 300;
    letter-spacing: 1px;
    line-height: 20px;
    text-transform: uppercase;
    cursor: pointer;
    padding: ${({ padding = null }) => padding};
    && {
      text-decoration: none;
    }
  `}

  ${device.mobile`
    width: 175px;
    border: 1px solid #999999
    border-radius: 10px;
    margin-bottom: 30px;
    font-size: 15px;
    height: 42px;
    font-family: "Avenir Light", "Arial", sans-serif;
    letter-spacing: 1px;
    text-transform: uppercase;
    text-align: center;
    vertical-align: center;
    line-height: 45px;
  `}
  ${device.all`
    display: inline-table;
  `}
`;

const NavigationLink = styled(UserLink)`
  ${device.all`
    font-weight: 900;
    line-height: 18px;
  
    &.fade-nav-appear {
      opacity: 0.01;
    }
  
    &.fade-nav-appear-active {
      opacity: 1;
      transition: opacity ${200}ms ease-out;
    }
  
    & > span {
      font-weight: 900;
      font-family: "Avenir", "Arial", sans-serif;
      ${({ underline, color }) => (underline ? `border-bottom: solid 3px ${color || '#000'};` : null)}
    }
  
    cursor: ${({ cursor = 'default' }) => cursor};
    ${({ hoverColor = null }) =>
      hoverColor
        ? `
          &:hover {
            color: ${hoverColor} !important;
          }
          `
        : null}
  `}
`;

const NavigationContentLinkTitle = styled(NavigationLink)`
  ${device.all`
    font-size: 15px;
    color: ${({ color }) => color || 'black'};
    cursor: pointer;
    &:hover {
      color: ${({ color }) => color || '#999'};
      text-decoration: underline;
    }
  `}
`;

const NavigationContentLink = styled(NavigationContentLinkTitle)`
  ${device.all`
    font-weight: 300;
    letter-spacing: 0px;
    font-family: "Avenir Light", "Arial", sans-serif;
    font-size: 15px;
    text-transform: capitalize;
    margin: 5px 30px 5px 0;
    &:hover {
      text-decoration: underline;
    }
  `}
`;

export { UserLink, NavigationLink, NavigationContentLink, NavigationContentLinkTitle };
